export const contactModel = {
    name: '',
    email: '',
    phone: '',
    message: ''
};
